import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { SNAPP_IR_LIST } from "../../hooks/constants";
export function SnappIrTravelServicesDesktop() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative hidden h-full items-center lg:flex">{SNAPP_IR_LIST.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(linkItem) {
  if (linkItem.subLinks) {
    return <ItemWithSubLinks title={linkItem.title} sublinks={linkItem.subLinks} />;
  }
  return <Button className="!mx-0" color="neutral" role="link" size="medium" href={linkItem.url} variant="text">{linkItem.title}</Button>;
}
const ItemWithSubLinks = t0 => {
  const $ = _c(10);
  const {
    title,
    sublinks
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon name="keyboard_arrow_down" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Button className="!mx-0" EndIcon={t1} aria-label={"\u062E\u062F\u0645\u0627\u062A \u0645\u0633\u0627\u0641\u0631\u062A\u06CC"} color="neutral" size="medium" variant="text">{title}</Button>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== sublinks) {
    t3 = sublinks?.map(_temp2);
    $[3] = sublinks;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <section className="opacity- pointer-events-none invisible absolute top-0 z-50 w-max translate-y-20 py-1 transition-all duration-150 ease-in-out group-hover:pointer-events-auto group-hover:visible group-hover:top-11 group-hover:translate-y-2 group-hover:opacity-100"><div className="elevation-8 rounded-lg"><div className="rounded-lg p-4"><div>{t3}</div></div></div></section>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="group">{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp2(item) {
  return <a className="hover:bg-states-secondary-dragged group/link group-hover/link:text-secondary flex h-12 w-48 items-center justify-start gap-2 rounded-lg px-2 py-3 transition-all" href={item.url} key={item.name}><div className="text-body-1 text-on-surface-high-emphasis group-hover/link:text-secondary">{item.name}</div></a>;
}